import {mainServer} from '../../../../variables/config'

export const request_insurance_carrier = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/insurancecarrier/"+id);
  return response.data.data.insurance_carrier
}
